// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vz_a bhf_b bhf_wb"};